<template>
  <div id="app">
      <Header/>
      <Banner />
      <About />
      <!-- <Usecase /> -->
      <Price />
      <Partners />
      <Footer/>
  </div>
</template>

<script>
import Header from '../components/Header.vue'

import Banner from '../components/Banner.vue'
import About from '../components/About.vue'
import Partners from '../components/Partners.vue'
// import Price from '../components/Price.vue'
import Price from '../components/PriceHorses.vue'

import Footer from '../components/Footer.vue'

export default {
  name: 'app',
  components: {
      Header,
    Banner,
    About,
    // Usecase,
    Price,
    Partners,
    Footer
  },
  data() {
      return {
       
      }
  },
}


</script>

